import { render, staticRenderFns } from "./DiscountPlanAdd.vue?vue&type=template&id=53967210&"
import script from "./DiscountPlanAdd.vue?vue&type=script&lang=js&"
export * from "./DiscountPlanAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports